import axios from 'services/api';
import { API2_HOST } from '../../helpers/urlHelper';
import { ApiResponse } from '../../helpers/stockLocationHelpers';
import { setItemToStore } from 'helpers/utils';
axios.defaults.withCredentials = true;
const baseURL = `${API2_HOST}/user-settings`;

const KEY_COL_SC_ACTION_PLAN = 'KEY_COL_SC_ACTION_PLAN';
const KEY_SORT_COL_SC_ACTION_PLAN = 'KEY_SORT_COL_SC_ACTION_PLAN';
const KEY_FILTER_SC_ACTION_PLAN = 'KEY_FILTER_SC_ACTION_PLAN';
const KEY_CF_MEETING_CONFIG = 'KEY_CF_MEETING_CONFIG';
const KEY_MEETING_DETAIL_CONFIG = 'KEY_MEETING_DETAIL_CONFIG';

const KEY_ACTION_PLAN_LIST_CONFIG = 'KEY_ACTION_PLAN_LIST_CONFIG';
const KEY_MEETING_LIST_CONFIG = 'KEY_MEETING_LIST_CONFIG';

const SM_TRAINING_NOTIFY_WHEN_TRAINING_EXPIRED = 'SM_TRAINING.NOTIFY_WHEN_TRAINING_EXPIRED';

const KEY_QUALITY_MAP_ZONES = 'KEY_QUALITY_MAP_ZONES';
const KEY_QUALITY_MAP_STAGE_ZONE = 'KEY_QUALITY_MAP_STAGE_ZONE';

const getSetting = async (key, isUseCache = true) => {
  const result = new ApiResponse();
  if (isUseCache) {
    const cache = sessionStorage.getItem(key);
    if (cache) {
      result.success = true;
      result.data = JSON.parse(cache);
      result.message = 'Data retrieved from cached';
      return result;
    }
  }
  const res = await axios.get(`${baseURL}/${key}`);
  if (res.status === 200 && res.data.success) {
    setItemToStore(key, JSON.stringify(res.data.data), sessionStorage);
    result.success = true;
    result.data = res.data.data;
    result.message = 'Data retrieved from API and cached';
  } else {
    result.message = 'Failed to retrieve data from API';
  }

  return result;
};

const saveSettings = async (key, value) => {
  const result = new ApiResponse();
  if (!key || !value) return result;
  await axios({
    method: 'patch',
    url: baseURL,
    data: { settingKey: key, settingValue: value },
    config: {
      headers: {
        Accept: 'application/json',
        'Content-type': 'application/json'
      }
    }
  })
    .then(res => {
      if (res.status == 200 && res.data?.success) {
        sessionStorage.removeItem(key);
        getSetting(key);
      }
    })
    .catch(error => {
      console.log('ERROR: ', { ...error });
    });
};

const getSystemSetting = async (key, isUseCache = true) => {
  const result = new ApiResponse();
  const cacheKey = `SYSTEM_${key}`;
  if (isUseCache) {
    const cache = sessionStorage.getItem(cacheKey);
    if (cache) {
      result.success = true;
      result.data = JSON.parse(cache);
      result.message = 'Data retrieved from cached';
      return result;
    }
  }
  const res = await axios.get(`${baseURL}/system/${key}`);
  if (res.status === 200 && res.data.success) {
    setItemToStore(cacheKey, JSON.stringify(res.data.data), sessionStorage);
    result.success = true;
    result.data = res.data.data;
    result.message = 'Data retrieved from API and cached';
  } else {
    result.message = 'Failed to retrieve data from API';
  }

  return result;
};

const saveSystemSettings = async (key, value) => {
  const result = new ApiResponse();
  if (!key || !value) return result;
  try {
    const res = await axios({
      method: 'patch',
      url: `${baseURL}/system`,
      data: { settingKey: key, settingValue: value },
      config: {
        headers: {
          Accept: 'application/json',
          'Content-type': 'application/json'
        }
      }
    });
    if (res.status === 200 && res.data?.success) {
      sessionStorage.removeItem(`SYSTEM_${key}`);
      result.success = true;
    } else {
      result.message = res.data?.message || 'Failed to save system setting';
    }
  } catch (error) {
    console.log('ERROR: ', { ...error });
    result.message = 'Failed to save system setting';
  }
  return result;
};

export {
  getSetting,
  saveSettings,
  getSystemSetting,
  saveSystemSettings,
  KEY_COL_SC_ACTION_PLAN,
  KEY_SORT_COL_SC_ACTION_PLAN,
  KEY_FILTER_SC_ACTION_PLAN,
  KEY_MEETING_DETAIL_CONFIG,
  KEY_ACTION_PLAN_LIST_CONFIG,
  KEY_CF_MEETING_CONFIG,
  KEY_MEETING_LIST_CONFIG,
  SM_TRAINING_NOTIFY_WHEN_TRAINING_EXPIRED,
  KEY_QUALITY_MAP_ZONES,
  KEY_QUALITY_MAP_STAGE_ZONE
};
